import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { Canvas as GCanvas } from '@antv/g';
import { Renderer as CanvasRenderer } from '@antv/g-canvas';
import { Plugin as DragAndDropPlugin } from '@antv/g-plugin-dragndrop';
import { debounce } from '@antv/util';
import EventEmitter from '@antv/event-emitter';
import { render as _render, destroy as _destroy } from '../runtime';
import { ChartEvent } from '../utils/event';
import { normalizeContainer, removeContainer, sizeOf, optionsOf, updateRoot, createEmptyPromise } from './utils';
import { CompositionNode } from './composition';
import { defineProps, nodeProps } from './define';
import { MarkNode } from './mark';
export var G2_CHART_KEY = 'G2_CHART_KEY';
export var Runtime = /*#__PURE__*/function (_CompositionNode) {
  _inherits(Runtime, _CompositionNode);
  function Runtime(options) {
    var _this;
    _classCallCheck(this, Runtime);
    var container = options.container,
      canvas = options.canvas,
      renderer = options.renderer,
      plugins = options.plugins,
      lib = options.lib,
      rest = __rest(options, ["container", "canvas", "renderer", "plugins", "lib"]);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Runtime).call(this, rest, 'view'));
    // Identifies whether bindAutoFit.
    _this._hasBindAutoFit = false;
    _this._rendering = false;
    _this._trailing = false;
    _this._trailingResolve = null;
    _this._trailingReject = null;
    _this._previousDefinedType = null;
    _this._onResize = debounce(function () {
      _this.forceFit();
    }, 300);
    _this._renderer = renderer || new CanvasRenderer();
    _this._plugins = plugins || [];
    _this._container = normalizeContainer(container);
    _this._emitter = new EventEmitter();
    _this._context = {
      library: lib,
      emitter: _this._emitter,
      canvas: canvas
    };
    _this._create();
    return _this;
  }
  _createClass(Runtime, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      if (this._rendering) return this._addToTrailing();
      if (!this._context.canvas) this._createCanvas();
      this._bindAutoFit();
      this._rendering = true;
      var finished = new Promise(function (resolve, reject) {
        return _render(_this2._computedOptions(), _this2._context, _this2._createResolve(resolve), _this2._createReject(reject));
      });
      var _createEmptyPromise = createEmptyPromise(),
        _createEmptyPromise2 = _slicedToArray(_createEmptyPromise, 3),
        finished1 = _createEmptyPromise2[0],
        resolve = _createEmptyPromise2[1],
        reject = _createEmptyPromise2[2];
      finished.then(resolve).catch(reject).then(function () {
        return _this2._renderTrailing();
      });
      return finished1;
    }
    /**
     * @overload
     * @param {G2ViewTree} [options]
     * @returns {Runtime|Spec}
     */
  }, {
    key: "options",
    value: function options(_options) {
      if (arguments.length === 0) return optionsOf(this);
      var type = _options.type;
      if (type) this._previousDefinedType = type;
      updateRoot(this, _options, this._previousDefinedType, this._marks, this._compositions);
      return this;
    }
  }, {
    key: "getContainer",
    value: function getContainer() {
      return this._container;
    }
  }, {
    key: "getContext",
    value: function getContext() {
      return this._context;
    }
  }, {
    key: "on",
    value: function on(event, callback, once) {
      this._emitter.on(event, callback, once);
      return this;
    }
  }, {
    key: "once",
    value: function once(event, callback) {
      this._emitter.once(event, callback);
      return this;
    }
  }, {
    key: "emit",
    value: function emit(event) {
      var _this$_emitter;
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      (_this$_emitter = this._emitter).emit.apply(_this$_emitter, [event].concat(args));
      return this;
    }
  }, {
    key: "off",
    value: function off(event, callback) {
      this._emitter.off(event, callback);
      return this;
    }
  }, {
    key: "clear",
    value: function clear() {
      var options = this.options();
      this.emit(ChartEvent.BEFORE_CLEAR);
      this._reset();
      _destroy(options, this._context, false);
      this.emit(ChartEvent.AFTER_CLEAR);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var options = this.options();
      this.emit(ChartEvent.BEFORE_DESTROY);
      this._unbindAutoFit();
      this._reset();
      _destroy(options, this._context, true);
      removeContainer(this._container);
      this.emit(ChartEvent.AFTER_DESTROY);
    }
  }, {
    key: "forceFit",
    value: function forceFit() {
      var _this3 = this;
      // Don't fit if size do not change.
      this.options['autoFit'] = true;
      var _sizeOf = sizeOf(this.options(), this._container),
        width = _sizeOf.width,
        height = _sizeOf.height;
      if (width === this._width && height === this._height) {
        return Promise.resolve(this);
      }
      // Don't call changeSize to prevent update width and height of options.
      this.emit(ChartEvent.BEFORE_CHANGE_SIZE);
      var finished = this.render();
      finished.then(function () {
        _this3.emit(ChartEvent.AFTER_CHANGE_SIZE);
      });
      return finished;
    }
  }, {
    key: "changeSize",
    value: function changeSize(width, height) {
      var _this4 = this;
      if (width === this._width && height === this._height) {
        return Promise.resolve(this);
      }
      this.emit(ChartEvent.BEFORE_CHANGE_SIZE);
      this.attr('width', width);
      this.attr('height', height);
      var finished = this.render();
      finished.then(function () {
        _this4.emit(ChartEvent.AFTER_CHANGE_SIZE);
      });
      return finished;
    }
  }, {
    key: "_create",
    value: function _create() {
      var _this5 = this;
      var library = this._context.library; // @todo After refactor component as mark, remove this.
      var isMark = function isMark(key) {
        return key.startsWith('mark.') || key === 'component.axisX' || key === 'component.axisY' || key === 'component.legends';
      };
      var marks = ['mark.mark'].concat(_toConsumableArray(Object.keys(library).filter(isMark)));
      // Create mark generators.
      this._marks = {};
      var _iterator = _createForOfIteratorHelper(marks),
        _step;
      try {
        var _loop = function _loop() {
          var key = _step.value;
          var name = key.split('.').pop();
          var Mark = /*#__PURE__*/function (_MarkNode) {
            _inherits(Mark, _MarkNode);
            function Mark() {
              _classCallCheck(this, Mark);
              return _possibleConstructorReturn(this, _getPrototypeOf(Mark).call(this, {}, name));
            }
            return Mark;
          }(MarkNode);
          _this5._marks[name] = Mark;
          _this5[name] = function (composite) {
            var node = this.append(Mark);
            if (name === 'mark') node.type = composite;
            return node;
          };
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
        // Create composition generators.
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var compositions = ['composition.view'].concat(_toConsumableArray(Object.keys(library).filter(function (key) {
        return key.startsWith('composition.') && key !== 'composition.mark';
      })));
      this._compositions = Object.fromEntries(compositions.map(function (key) {
        var name = key.split('.').pop();
        var Composition = /*#__PURE__*/function (_CompositionNode2) {
          _inherits(Composition, _CompositionNode2);
          function Composition() {
            _classCallCheck(this, Composition);
            return _possibleConstructorReturn(this, _getPrototypeOf(Composition).call(this, {}, name));
          }
          return Composition;
        }(CompositionNode);
        Composition = __decorate([defineProps(nodeProps(_this5._marks))], Composition);
        return [name, Composition];
      }));
      for (var _i = 0, _Object$values = Object.values(this._compositions); _i < _Object$values.length; _i++) {
        var Ctor = _Object$values[_i];
        defineProps(nodeProps(this._compositions))(Ctor);
      }
      var _iterator2 = _createForOfIteratorHelper(compositions),
        _step2;
      try {
        var _loop2 = function _loop2() {
          var key = _step2.value;
          var name = key.split('.').pop();
          _this5[name] = function () {
            var Composition = this._compositions[name];
            this.type = null;
            return this.append(Composition);
          };
        };
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          _loop2();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "_reset",
    value: function _reset() {
      var KEYS = ['theme', 'type', 'width', 'height', 'autoFit'];
      this.type = 'view';
      this.value = Object.fromEntries(Object.entries(this.value).filter(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
          key = _ref2[0];
        return key.startsWith('margin') || key.startsWith('padding') || key.startsWith('inset') || KEYS.includes(key);
      }));
      this.children = [];
    }
  }, {
    key: "_renderTrailing",
    value: function _renderTrailing() {
      var _this6 = this;
      if (!this._trailing) return;
      this._trailing = false;
      this.render().then(function () {
        var trailingResolve = _this6._trailingResolve.bind(_this6);
        _this6._trailingResolve = null;
        trailingResolve(_this6);
      }).catch(function (error) {
        var trailingReject = _this6._trailingReject.bind(_this6);
        _this6._trailingReject = null;
        trailingReject(error);
      });
    }
  }, {
    key: "_createResolve",
    value: function _createResolve(resolve) {
      var _this7 = this;
      return function () {
        _this7._rendering = false;
        resolve(_this7);
      };
    }
  }, {
    key: "_createReject",
    value: function _createReject(reject) {
      var _this8 = this;
      return function (error) {
        _this8._rendering = false;
        reject(error);
      };
    } // Update actual size and key.
  }, {
    key: "_computedOptions",
    value: function _computedOptions() {
      var options = this.options();
      var _options$key = options.key,
        key = _options$key === void 0 ? G2_CHART_KEY : _options$key;
      var _sizeOf2 = sizeOf(options, this._container),
        width = _sizeOf2.width,
        height = _sizeOf2.height,
        depth = _sizeOf2.depth;
      this._width = width;
      this._height = height;
      this._key = key;
      return Object.assign(Object.assign({
        key: this._key
      }, options), {
        width: width,
        height: height,
        depth: depth
      });
    } // Create canvas if it does not exist.
    // DragAndDropPlugin is for interaction.
    // It is OK to register more than one time, G will handle this.
  }, {
    key: "_createCanvas",
    value: function _createCanvas() {
      var _this9 = this;
      var _sizeOf3 = sizeOf(this.options(), this._container),
        width = _sizeOf3.width,
        height = _sizeOf3.height;
      this._plugins.push(new DragAndDropPlugin());
      this._plugins.forEach(function (d) {
        return _this9._renderer.registerPlugin(d);
      });
      this._context.canvas = new GCanvas({
        container: this._container,
        width: width,
        height: height,
        renderer: this._renderer
      });
    }
  }, {
    key: "_addToTrailing",
    value: function _addToTrailing() {
      var _this10 = this;
      var _a;
      // Resolve previous promise, and give up this task.
      (_a = this._trailingResolve) === null || _a === void 0 ? void 0 : _a.call(this, this);
      // Create new task.
      this._trailing = true;
      var promise = new Promise(function (resolve, reject) {
        _this10._trailingResolve = resolve;
        _this10._trailingReject = reject;
      });
      return promise;
    }
  }, {
    key: "_bindAutoFit",
    value: function _bindAutoFit() {
      var options = this.options();
      var autoFit = options.autoFit;
      if (this._hasBindAutoFit) {
        // If it was bind before, unbind it now.
        if (!autoFit) this._unbindAutoFit();
        return;
      }
      if (autoFit) {
        this._hasBindAutoFit = true;
        window.addEventListener('resize', this._onResize);
      }
    }
  }, {
    key: "_unbindAutoFit",
    value: function _unbindAutoFit() {
      if (this._hasBindAutoFit) {
        this._hasBindAutoFit = false;
        window.removeEventListener('resize', this._onResize);
      }
    }
  }]);
  return Runtime;
}(CompositionNode);